//name:路由名称
//expand:用于底部导航栏展开隐藏
//id:用于同一个页面上某个模块的id
//en: banner图英文

import i18n from '@/locales';

// 在 const.js 中使用 $t 的辅助函数（等同于 $t）
export const $t = (key) => i18n.t(key);

// 获取菜单项翻译后的标签
export const getMenuLabel = (item) => {
	return item.labelKey ? i18n.t(item.labelKey) : item.label || '';
};

export const MENU  = () => [
    {
        label: $t('menu.home'),
        name: 'home',
        en:'Aidite Investor Relations'
    },
    {
        label: $t('menu.business_rules'),
        name: 'business_rules',
        expand:'business', 
        en:'Corporate governance',
        children:[
            {
                label: $t('menu.business_rules_intro'),
                id:'management',
                name: 'business_rules',
            },
            {
                label: $t('menu.structural'),
                id:'structural',
                name: 'business_rules',
            },
            {
                label: $t('menu.supervisors'),
                id:'supervisors',
                name: 'business_rules',
            },
            {
                label: $t('menu.sustain'),
                name: 'sustain',
            },
        ]
    },
    {
        label: $t('menu.quote'),
        name: 'quote',
        en: 'Share information'
    },
    {
        label: $t('menu.investment'),
        name:'investment',
        expand:'investment',
        en:'News and Events',
        children:[
            {
                label: $t('menu.news'),
                name:'news',
                children: [
                    {
                        label: $t('menu.newsDetail'),
                        name:'newsDetail',
                    }
                ]
            },
            {
                label: $t('menu.calendar'),
                name:'investment',
            },
            {
                label: $t('menu.analyst'),
                name:'analyst',
            },
            {
                label: $t('menu.report'),
                name:'report',
            },
            {
                label: $t('menu.presentation'),
                name: 'presentation',
            },
        ]
    },
    {
        label: $t('menu.quarterly_performance'),
        name:'quarterly_performance',
        expand:'finance',
        en:'Announcement',
        children:[
            {
                label: $t('menu.regular_report'),
                name:'quarterly_performance'
            },
            {
                label: $t('menu.announcement'),
                name:'announcement'
            }
        ]
    },
    {
        label: $t('menu.question'),
        name:'question',
        expand:'serve',
        en:'Investor Service',
        children:[
            {
                label: $t('menu.faq'),
                name:'question'
            },
            {
                label: $t('menu.contact'),
                name:'contact'
            }
        ]
    },
]